<template>
  <div class="d-flex flex-row cer-nav-list">
    <a class="cert-nav-logo d-none d-xl-flex flex-row" href="//cyber.gov.rw" target="_blank">
      <div class="cert-nav-logo-text my-auto">NCSA</div>
    </a>
    <div class="d-none d-xl-flex" style="width: 1px; background-color: #000000;opacity: 0.2; margin: 12px 8px 12px 16px"></div>
    <a class="cert-nav-logo mr-auto d-none d-xl-flex flex-row" @click="()=>$router.push({path:'/home'})">
      <div class="cert-nav-logo-text my-auto">RW-CERT</div>
    </a>

    <div class="cert-navbar-nav d-flex flex-column flex-xl-row navbar-nav ml-auto">

      <div class="nav-item mr-auto mr-xl-0">
        <div @click="nav('/about')"
             class="cert-nav-item" :class="getRoute() === 'about' ? 'active' : ''">
          <div class="cert-text">About Us</div>
        </div>
      </div>

      <div class="nav-item mr-auto mr-xl-0">
        <div @click="nav('/services')"
             class="cert-nav-item" :class="getRoute() === 'services' ? 'active' : ''">
          <div class="cert-text">Services</div>
        </div>
      </div>
      <div class="nav-item mr-auto mr-xl-0">
        <div @click="nav('/alerts')"
             class="cert-nav-item" :class="getRoute() === 'alerts' ? 'active' : ''">
          <div class="cert-text">Alerts</div>
        </div>
      </div>
      <div class="nav-item mr-auto mr-xl-0">
        <div @click="nav('/advisories')"
             class="cert-nav-item" :class="getRoute() === 'advisories' ? 'active' : ''">
          <div class="cert-text">Advisories</div>
        </div>
      </div>
      <cert-nav-drop-down title="Resources" :links="resources" :request-close="onRequestClose"/>
      <cert-nav-drop-down title="Report Cyber Issue" :links="reporting" :accent="true" :request-close="onRequestClose"/>
      <div class="nav-item mr-auto mr-xl-0">
        <div @click="nav('/contact')"
             class="cert-nav-item" :class="getRoute() === 'contact' ? 'active' : ''">
          <div class="cert-text">Contact Us</div>
        </div>
      </div>

      <div class="cert-nav-icon d-none d-xl-flex px-4" @click="nav('/search')">
        <micon icon="search" class="mx-auto my-auto"/>
      </div>
      <div class="nav-item d-flex d-xl-none">
        <div @click="nav('/search')"
             class="cert-nav-item" :class="getRoute() === 'search' ? 'active' : ''">
          <div class="cert-text">Search</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import SidenavItem from "./SidenavItem.vue";
import CertNavDropDown from "../../views/cert/components/CertNavDropDown";

export default {
  name: "SidenavList",
  components: {
    // SidenavItem,
    CertNavDropDown,
  },
  props: {
    cardBg: String,
    requestClose: Function,
  },
  data() {
    return {
      title: "Rw-CERT",
      controls: "",
      isActive: "active",
      reporting: [
        {
          title: "Report Incident",
          path: "/report-incident",
          external: false,
        },
        {
          title: "Report Vulnerability",
          path: "/report-vulnerability",
          external: false,
        },
      ],
      resources: [
        {
          title: "Legal and regulatory ",
          path: "/legal",
          external: false,
        },
        {
          title: "Guidelines",
          path: "/guidelines",
          external: false,
        },
        {
          title: "Tools",
          path: "/tools",
          external: false,
        },
        {
          title: "PGP Public Keys",
          path: "/keys",
          external: false,
        },
        {
          title: "RFC2350",
          path: "cyber.gov.rw/index.php?eID=dumpFile&t=f&f=346&token=46f9506ee0b1ff8c9cd629cc5c40b17bf6785105",
          external: true,
        },
        // {
        //   title: "NCSA Website",
        //   path: "cyber.gov.rw",
        //   external: true,
        // },
      ]
    };
  },

  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    contact() {
      this.$router.push({path: "/contact"})
    },
    nav(path) {
      this.requestClose();
      this.$router.push({path: path})
    },
    onRequestClose() {
      this.requestClose();
    }
  }
};
</script>
